$(document).ready(function () {
  // Moves the cursor to the end of the input instead of the front, which is
  // the default for many browsers.
  //
  // See: http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
  var moveCursorToEndOfLine = function($input) {
    $input.focus();
    var val = $input.val(); //store the value of the element
    $input.val(''); //clear the value of the element
    $input.val(val);
  };
  moveCursorToEndOfLine($('.js-end-of-line-cursor'));
  moveCursorToEndOfLine($('.js-focus-eol'));
});
